<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title class="export-title font-lang-10">Export to CSV</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close class="export-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="formGroup" >
      <p class="text-bold font-lang-5">Total Users: {{ userCount() }}</p>
      <p class="text-bold font-lang-5">Customize your CSV file by selecting the user data columns to export:</p>
      <div>
        <ul class="checkbox-list">
          <li>
            <mat-checkbox class="bigger-checkbox"
              formControlName="selectAll"
              [indeterminate]="indeterminate()"
              aria-label="Select all"
              (change)="selectAllChange($event)"
              >
              Select all
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="name" aria-label="Name" (change)="checkboxChange()">
              Name
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="email" aria-label="Email"
              (change)="checkboxChange()">
              Email
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="phone" aria-label="Phone number"
              (change)="checkboxChange()">
              Phone number
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="positions" aria-label="Positions"
              (change)="checkboxChange()">
              Positions
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Specific position(s)</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificPositions" multiple
                  (selectionChange)="selectionChange($event, 'specificPositions')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificPositions'].value.includes('all')) {
                      All positions
                    } @else {
                      {{ getSelectedTexts('specificPositions', data.positions) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All positions</mat-option>
                  @for (position of data.positions; track position) {
                    <mat-option [value]="position.value">{{ position.text }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="agency" aria-label="Agency"
              (change)="checkboxChange()">
              Agency
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Specific agency(s)</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificAgencies" multiple
                  (selectionChange)="selectionChange($event, 'specificAgencies')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificAgencies'].value.includes('all')) {
                      All agencies
                    } @else {
                      {{ getSelectedTexts('specificAgencies', data.agencies) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All agencies</mat-option>
                  @for (agency of data.agencies; track agency) {
                    <mat-option [value]="agency.value">{{ agency.text }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="location"
              aria-label="Location (Region/WO and Forest)" (change)="checkboxChange()">
              Location (Region/WO and Forest)
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Specific regions(s)</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificRegions" multiple
                  (selectionChange)="selectionChange($event, 'specificRegions')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificRegions'].value.includes('all')) {
                      All regions
                    } @else {
                      {{ getSelectedTexts('specificRegions', data.regions, false) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All regions</mat-option>
                  @for (region of data.regions; let i = $index; track i) {
                    <mat-option [value]="region">{{ region }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <p class="text-bold font-lang-5 select-label">Specific forest(s)</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificForests" multiple
                  (selectionChange)="selectionChange($event, 'specificForests')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificForests'].value.includes('all')) {
                      All forests
                    } @else {
                      {{ getSelectedTexts('specificForests', data.forests, false) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All forests</mat-option>
                  @for (forest of data.forests; let i = $index; track i) {
                    <mat-option [value]="forest">{{ forest }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="assignmentStatus" aria-label="Fire Assignment Status"
              (change)="checkboxChange()">
              Fire Assignment Status
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Select Status</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificAssignmentStatuses" multiple
                  (selectionChange)="selectionChange($event, 'specificAssignmentStatuses')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificAssignmentStatuses'].value.includes('all')) {
                      All statuses
                    } @else {
                      {{ getSelectedTexts('specificAssignmentStatuses', assignmentStatuses) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All statuses</mat-option>
                  @for (status of assignmentStatuses; let i = $index; track i) {
                    <mat-option [value]="status.value">{{ status.text }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox" formControlName="skills" aria-label="Skills"
              (change)="checkboxChange()">
              Skills
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Specific skill(s)</p>
              <mat-form-field appearance="outline" class="select-field">
                <mat-select formControlName="specificSkills" multiple
                  (selectionChange)="selectionChange($event, 'specificSkills')">
                  <mat-select-trigger>
                    @if (formGroup.controls['specificSkills'].value.includes('all')) {
                      All skills
                    } @else {
                      {{ getSelectedTexts('specificSkills', data.skills) }}
                    }
                  </mat-select-trigger>
                  <mat-option value="all">All skills</mat-option>
                  @for (skill of data.skills; track skill) {
                    <mat-option [value]="skill.value">{{ skill.text === 'GIS' ? 'GIS Specialist' : skill.text }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (showCertOptions()) {
                <p class="text-bold font-lang-5 select-label">Specific GIS specialist certification(s)</p>
                <span class="select-field">
                  <mat-checkbox class="bigger-checkbox" formControlName="vgisCertified" aria-label="VGIS Certified"
                    (change)="checkboxChange(true)">
                    VGIS Certified
                  </mat-checkbox>
                  <mat-checkbox class="bigger-checkbox second-inline-checkbox" formControlName="nisBaerCertified"
                    aria-label="NIS-BAER Certified" (change)="checkboxChange(true)">
                    NIS-BAER Certified
                  </mat-checkbox>
                </span>
              }
            </div>
          </li>
        </ul>
      </div>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row-always">
      <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button class="usa-button" (click)="exportToCsv()" [disabled]="filteredUsers().length === 0">
        Export
      </button>
    </div>
  </div>
</div>
